var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-mobile"},[_c('b-container',[_c('upper-part'),_c('lower-part')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }